export const texts = {
  meta_title: 'All Nations Convocation Jerusalem 2021 | Live | JHOPFAN',
  meta_desc: 'Join us live online for the All Nations Convocation Jerusalem 2021.',
  home_title: 'All Nations Convocation Jerusalem 2021',
  home_subtitle: 'The Glory of the King is Shining Upon You',
  golbal_prayer_link_path: 'https://us02web.zoom.us/j/84762687520?pwd=NVR1SHNydUNWeGoyVHlSODZRQVRLQT09'
}
